/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import './navBar.scss'
import {Link, withRouter, useLocation, useParams } from "react-router-dom";
import EXP_CONSTS from '../../common/constants'
const NavBar = (props) => {
     let location = useLocation();
    let fullPath = location.pathname.split('/');
    let modulePath = fullPath[1];
    let personTypeId = props.userData.personTypeId;
    let roleArray = EXP_CONSTS.IMPERSONATE_ROLES;
        
    return(
        <div>
            <div className="logo logo-myhub">
                    </div>
                    {props.isUserSubscribed && modulePath != 'noSubscription' && 
                    <div className="menulist">
                        <Link className={modulePath ==''? 'active': ''} to="/" >Dashboard</Link>
                        <Link className={['groups', 'group'].indexOf(modulePath) > -1? 'active': ''} to="/groups" >Groups</Link>
                        <Link className={['students', 'student', 'studentAssessment'].indexOf(modulePath) > -1? 'active': ''} to="/students" >Students</Link>
                          <Link className={['assessments', 'assessment'].indexOf(modulePath) > -1? 'active': ''} to="/assessments" >Assessments</Link>
                          {roleArray.indexOf(personTypeId) > -1 && <Link className={['impersonate'].indexOf(modulePath) > -1 ? 'active' : ''} to="/impersonate" >Impersonate</Link>} 
                    </div>
                    }
        </div>
    )
}
   

    


export default withRouter(NavBar);